import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getFriends, getTopUsers, getUser } from '../api/user';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Leaderboard, RootState } from '../redux/type';
import { setFriends, setLeaderboard, setTasks, setUserData } from '../redux/actions';
import { getTasksApi } from '../api/task';
import Loading from '../components/Loading';
import { getMaintenanceMode } from '../api/admin';

const GlobalMiddleware = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.userData);
  const leaderboard = useSelector((state: RootState) => state.leaderboard);
  const tasks = useSelector((state: RootState) => state.tasks);
  // const friends = useSelector((state: RootState) => state.friends);
  const [isLoading, setIsLoading] = useState(true);

  const updateLeaderboard = async (id) => {
    const newLeaderboard: Leaderboard = await getTopUsers(id);
    if (!newLeaderboard) return;
    dispatch(setLeaderboard(newLeaderboard));
  };

  const updateUserData = async (id) => {
    const userData = await getUser(id);
    if (!userData) return;
    dispatch(setUserData(userData));
  };

  const updateTasks = async (id) => {
    const newTasks = await getTasksApi(id);
    if (!newTasks) return;
    dispatch(setTasks(newTasks));
  };

  const updateFriends = async (id) => {
    // const newFriends = await getFriends(id);
    // if (!newFriends) return;
    // dispatch(setFriends(newFriends));
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const queryParams = new URLSearchParams(location.search);

        const uid = queryParams.get('uid');

        if (uid) {
          localStorage.setItem('global_uid', uid);
        }

        const storedUid = localStorage.getItem('global_uid');
        console.log(storedUid);

        if (!storedUid) {
          navigate('/restricted');
          setIsLoading(false);
          return;
        }

        const user = await getUser(storedUid);
        if (!user || user.banned) {
          navigate('/restricted');
          setIsLoading(false);
          return;
        }

        const maintenanceMode = await getMaintenanceMode();
        if (maintenanceMode && user.role !== 'admin') {
          navigate('/maintenance');
          setIsLoading(false);
          return;
        }

        await Promise.all([
          updateLeaderboard(storedUid),
          updateTasks(storedUid),
          updateFriends(storedUid),
        ]);

        dispatch(setUserData(user));
      } catch (error) {
        console.error('Error fetching user data:', error);
        navigate('/restricted');
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return <>{children}</>;
};

export default GlobalMiddleware;
